interface FilterGroupProps {
  title: string;
  options: string[];
  value: string;
  onChange: (value: string) => void;
}

export default function FilterGroup({ title, options, value, onChange }: FilterGroupProps) {
  return (
    <div>
      <h3 className="mb-2.5 font-heading text-sm font-semibold text-foreground-900">{title}</h3>
      <div className="flex flex-wrap gap-2">
        {options.map((option) => {
          const isActive = option === value;
          return (
            <button
              key={option}
              type="button"
              onClick={() => onChange(option)}
              className={
                isActive
                  ? "whitespace-nowrap rounded-md bg-primary-600 px-3 py-1.5 text-xs font-medium text-background-50 transition-colors"
                  : "whitespace-nowrap rounded-md border border-background-300 px-3 py-1.5 text-xs font-medium text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600"
              }
            >
              {option}
            </button>
          );
        })}
      </div>
    </div>
  );
}